import React from 'react';
const Organization = React.lazy(() => import('./views/organization/Organization'));
const OrganizationRegister = React.lazy(() => import('./views/organization/OrganizationRegister'));
const OrganizationUpdate = React.lazy(() => import('./views/organization/OrganizationUpdate'));
const OrganizationDeleteConfirm = React.lazy(() =>
  import('./views/organization/OrganizationDeleteConfirm')
);
const UserList = React.lazy(() => import('./views/user-list/UserList'));
const UserRegister = React.lazy(() => import('./views/user-list/UserRegister'));
const UserUpdate = React.lazy(() => import('./views/user-list/UserUpdate'));
const UserDeleteConfirm = React.lazy(() => import('./views/user-list/UserDeleteConfirm'));
const SiteListComponent = React.lazy(() => import('./views/sites/siteListPage'));
const CreateSiteListComponent = React.lazy(() => import('./views/sites/createSiteList'));
const EditSiteListComponent = React.lazy(() => import('./views/sites/editSiteList'));
const DeleteSiteListComponent = React.lazy(() => import('./views/sites/deleteSiteList'));
const ErrorPage = React.lazy(() => import('./views/err/errorPage'));
const routes = [
  {
    path: '/err',
    exact: true,
    name: 'Error',
    component: ErrorPage,
  },
  { path: ['/organization'], exact: true, name: '組織一覧', component: Organization },
  {
    path: '/organization-register',
    exact: true,
    name: '組織登録',
    component: OrganizationRegister,
  },
  { path: '/organization-update', exact: true, name: '組織更新', component: OrganizationUpdate },
  {
    path: '/organization-delete-confirm',
    exact: true,
    name: '登録削除',
    component: OrganizationDeleteConfirm,
  },
  { path: '/user', exact: true, name: 'ユーザー一覧', component: UserList },
  { path: '/user-register', exact: true, name: 'ユーザー登録', component: UserRegister },
  { path: '/user-update', exact: true, name: 'ユーザー更新', component: UserUpdate },
  { path: '/user-delete-confirm', exact: true, name: 'ユーザー削除', component: UserDeleteConfirm },
  { path: '/site', exact: true, name: 'サイト一覧', component: SiteListComponent },
  { path: '/site-register', exact: true, name: 'サイト一覧', component: CreateSiteListComponent },
  { path: '/site-update', exact: true, name: 'サイト一覧', component: EditSiteListComponent },
  { path: '/site-delete-confirm', exact: true, name: 'サイト一覧', component: DeleteSiteListComponent },
];

export default routes;
